var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJungle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.897 11.453S3.38 7.233 0 4.439c0 0 4.587 1.972 5.553 5.04 0 0 1.086-4.383-2.475-9.479 0 0 8.57 8.932 5.13 16 0 0-2.414-3.123-5.31-4.547zm6.571-2.028s-.663-2.52-1.207-3.123c0 0 2.234-4.329 4.346-6.302 0 0-2.656 4.603-2.414 8 0 0-.543.768-.725 1.425zM16 4c-5.432 2.52-5.673 9.151-5.673 9.151.422-.877 2.836-2.301 2.836-2.301C12.56 7.069 16 4 16 4z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/roles/alt-3/jungle.svg";
export { SvgJungle as ReactComponent };